<script setup lang="ts">
import { FeedbackMessage, FeedbackMessageState } from '@kiplin/web-common/design-system';

defineProps<{
  helpText?: string;
  errors?: string[];
  helpTextId?: string;
  errorId?: string;
}>();
</script>

<template>
  <div>
    <!--    TODO : voir si on supprime cette partie helper-->
    <FeedbackMessage v-if="helpText" :id="helpTextId" :text="helpText" :state="FeedbackMessageState.Default" />

    <FeedbackMessage
      v-for="(error, index) in errors ?? []"
      :id="index === 0 ? errorId : undefined"
      :key="`${index}-${error}`"
      :text="error"
      :state="FeedbackMessageState.Error"
      role="alert"
    />
  </div>
</template>
